import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { IconButton, MenuItem, Popover } from '@mui/material';

import NavMenuSignoutButton from '../NavMenuSignoutButton';
import NavMenuSelectCustomer from '../NavMenuSelectCustomer';

import { getNameAccordingToInsuranceCategory } from '../../../utils/customerUtils';
import UserIcon from '../../../icons/UserIcon';

import {
  StyledUserDropdown,
  StyledSignoutButtonContainer,
  StyledUserMenuList,
} from './UserDropdownDesktop.styled';

function UserDropdown(props) {
  const { customers, customer, trackDtEvent, customerSelect, isCustomerLoading } = props;

  const intl = useIntl();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const inactiveContractText = intl.formatMessage({ id: 'contract.placeholder.inactive' });

  const handleClick = (event) => {
    if (!isCustomerLoading) {
      if (trackDtEvent) {
        trackDtEvent('click person logo', customer);
      }

      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  if (!customer) return null;

  return (
    <StyledUserDropdown>
      <IconButton
        size="large"
        onClick={handleClick}
        disabled={isCustomerLoading}
        aria-label="Open User"
        aria-controls={open ? 'user-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
      >
        <UserIcon />
      </IconButton>

      <Popover
        anchorEl={anchorEl}
        id="user-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <StyledUserMenuList>
          {customers?.map((customerItem) => {
            const { key, policyName, endedContract, insuranceCategory, uuid } = customerItem;
            const contractEnded = endedContract === 'true';
            const policyDisplayName = contractEnded ? inactiveContractText : policyName;
            const customerName = getNameAccordingToInsuranceCategory(customerItem);
            const isCurrentCustomer = customer?.key === key;

            return (
              <MenuItem
                dense
                key={key}
                onClick={() => customerSelect(uuid)}
                aria-label={`${customerName} ${policyDisplayName} ${isCurrentCustomer ? 'selected' : ''}`}
                disabled={contractEnded}
              >
                <NavMenuSelectCustomer
                  policyName={policyDisplayName}
                  customerName={customerName}
                  insuranceCategory={insuranceCategory}
                  isCurrentCustomer={isCurrentCustomer}
                  contractEnded={contractEnded}
                />
              </MenuItem>
            );
          })}
        </StyledUserMenuList>

        <StyledSignoutButtonContainer>
          <NavMenuSignoutButton onSignout={handleClose} />
        </StyledSignoutButtonContainer>
      </Popover>
    </StyledUserDropdown>
  );
}

export default UserDropdown;

UserDropdown.defaultProps = {
  customers: [],
  isCustomerLoading: false,
  customerSelect: () => {},
};

UserDropdown.propTypes = {
  isCustomerLoading: PropTypes.bool,
  trackDtEvent: PropTypes.func,
  customerSelect: PropTypes.func,
  customers: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      policyName: PropTypes.string,
      endedContract: PropTypes.string,
      uuid: PropTypes.string,
    })
  ),
  customer: PropTypes.shape({
    insuranceCategory: PropTypes.string,
  }),
};
